import LoginView from "../views/login/LoginView.vue";
import ConfigContaView from "../views/config-conta/ConfigContaView.vue";
import SincronizarView from '../views/sincronizar-dados/SincronizarView.vue'

export default [
  {
    path: "/login",
    name: "Coasul - Login",
    component: LoginView,
    meta: {
      requiresAuth: false,
      sync: false,
      online: false
    },
  },
  {
    path: "/config-conta",
    name: "Configurações Conta",
    component: ConfigContaView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true
    },
  },
  {
    path: "/sincronizar",
    name: "Sincronizar Dados",
    component: SincronizarView,
    meta: {
      requiresAuth: true,
      sync: false,
      online: false
    },
  },
];
